import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';

/** Path for a lazy-loaded child route (e.g. /kalio-products). */
export function resolveRoutePath(route: ActivatedRouteSnapshot): string {
  const configPath = route.routeConfig?.path;
  if (configPath && configPath !== '**' && !configPath.includes(':')) {
    return '/' + configPath;
  }

  const segments = route.pathFromRoot
    .flatMap(r => r.url.map(s => s.path))
    .filter(Boolean);
  return segments.length ? '/' + segments.join('/') : '/';
}

/**
 * True when the user may open this route.
 * Navigation API already filters menu by role/permission; allowedRoutes is authoritative per business.
 */
export function canAccessRoute(
  route: ActivatedRouteSnapshot,
  authService: AuthService,
  navigationService: NavigationService
): boolean {
  const requiredPermission = route.data['permission'] as string | undefined;
  const path = resolveRoutePath(route);

  if (authService.isAdmin()) {
    return true;
  }

  if (requiredPermission && authService.hasPermission(requiredPermission)) {
    return true;
  }

  if (navigationService.menuLoaded && navigationService.isRouteAllowed(path)) {
    return true;
  }

  return false;
}
